import FingerprintJS from "@fingerprintjs/fingerprintjs";

let visitorIdPromise: Promise<string> | null = null;

/**
 * Returns a stable browser fingerprint (32-char hex visitorId).
 * The FingerprintJS agent is loaded once and the result is cached
 * for the lifetime of the page.
 */
export function getFingerprint(): Promise<string> {
  if (!visitorIdPromise) {
    visitorIdPromise = FingerprintJS.load()
      .then((fp) => fp.get())
      .then((result) => result.visitorId);
  }

  return visitorIdPromise;
}
